import _ from 'lodash'

export default {
  'CHANGE_NOTIFICATIONS_PANEL' (state, payload) {
    payload = JSON.stringify(payload)
    state.notificationsPanel = JSON.parse(payload)
    window.localStorage.setItem('notificationsPanel', payload)
  },
  'CHANGE_ORDERS' (state, payload) {
    state.orders = payload
    if (isNaN(state.orders)) state.orders = 0
    window.localStorage.setItem('orders', state.orders)
  },
  'CHANGE_UNREAD_MESSAGES' (state, payload) {
    payload = Object.assign({}, state.unreadMessages, payload)
    state.unreadMessages = payload
    window.localStorage.setItem('unreadMessages', JSON.stringify(state.unreadMessages))
  },
  'CHANGE_USER' (state, payload) {
    payload = Object.assign({}, state.user, payload)
    state.user = JSON.parse(JSON.stringify(payload))
    window.localStorage.setItem('user', JSON.stringify(state.user))
  },
  'CHANGE_RECENT_CLIENTS' (state, payload) {
    if (!state.recentClients) state.recentClients = []
    let index = _.findIndex(state.recentClients, (rc) => {
      return rc.id === payload.id
    })
    if (index >= 0) state.recentClients.splice(index, 1)
    state.recentClients.unshift(payload)
    state.recentClients = state.recentClients.slice(0, 5)
    window.localStorage.setItem('recentClients', JSON.stringify(state.recentClients))
  },
  'UNSET_USER' (state) {
    state.user = false
    window.localStorage.removeItem('user')
  },
  'SAVE_RENT' (state, payload) {
    payload = Object.assign({}, state.rent, payload)
    state.rent = payload
    window.localStorage.setItem('rent', JSON.stringify(state.rent))
  },
  'UNSET_RENT' (state) {
    state.rent = false
    window.localStorage.removeItem('rent')
  },
  'CHANGE_NOTIFICATIONS_GENERAL' (state, payload) {
    if (payload === 'clear') {
      state.notifictionsGeneral = 0
      window.localStorage.removeItem('notifictionsGeneral', JSON.stringify(state.notifictionsGeneral))
      return
    }
    if (payload === 'add') {
      state.notifictionsGeneral += 1
      window.localStorage.setItem('notifictionsGeneral', JSON.stringify(state.notifictionsGeneral))
    }
  },
  'SET_OPENED_ON_MANAGEMENT_SITE' (state, payload) {
    if (!state.openedOnManagementSite) state.openedOnManagementSite = []

    let index = _.findIndex(state.openedOnManagementSite, (oms) => {
      return oms.id === state.openedOnManagementSite.id
    })

    if (index >= 0) state.openedOnManagementSite.splice(index, 1)

    state.openedOnManagementSite.unshift(payload)
    window.localStorage.setItem('configModalReviewsClient', JSON.stringify(state.openedOnManagementSite))
  },
  'REMOVE_OPENED_ON_MANAGEMENT_SITE' (state, payload) {
    if (!state.openedOnManagementSite) return
    if (state.openedOnManagementSite.length === 0) {
      window.localStorage.removeItem('configModalReviewsClient')
    } else {
      let index = _.findIndex(state.openedOnManagementSite, (oms) => {
        return oms.id === payload
      })
      if (index >= 0) {
        state.openedOnManagementSite.splice(index, 1)
        window.localStorage.setItem('configModalReviewsClient', JSON.stringify(state.openedOnManagementSite))
      }
    }
  },
  'CHANGE_NEW_CLIENTS' (state, payload) {
    if (payload === 'decrement_all') {
      state.newClients = 0
      window.localStorage.removeItem('newClients')
    } else {
      state.newClients = payload
      window.localStorage.setItem('newClients', state.newClients)
    }
  },
  'PUSH_PHOTO_CLIENTS' (state, payload) {
    state.photosNotificationClients.push(payload)
    window.localStorage.setItem('photosNotification', JSON.stringify(state.photosNotificationClients))
  },
  'REMOVE_PHOTO_CLIENTS' (state, id) {
    state.photosNotificationClients = _.filter(state.photosNotificationClients, (c) => {
      return c.id !== id
    })
    window.localStorage.setItem('photosNotification', JSON.stringify(state.photosNotificationClients))
  },
  'UPDATE_PHOTO_CLIENTS' (state, id) {
    state.photosNotificationClients = _.map(state.photosNotificationClients, (c) => {
      if (c.id === id) {
        c.isOpenedOnSite = 1
      }
      return c
    })
    window.localStorage.setItem('photosNotification', JSON.stringify(state.photosNotificationClients))
  },
  'PUSH_NOTIFICATIONS' (state, payload) {
    state.notifications.push(payload)
    window.localStorage.setItem('notifications', JSON.stringify(state.notifications))
  },
  'DECREASE_NOTIFICATIONS' (state, payload) {
    state.notifications = _.filter(state.notifications, (n) => {
      return n.id !== payload.id
    })
    window.localStorage.setItem('notifications', JSON.stringify(state.notifications))
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js